import { IntegrationAccount } from '@phrasee/phrasee-typings'

import { CepIntegration } from 'common/api'

import AccountGridCepIntegration from './AccountGridCepIntegration'
import AccountsGrid from './AccountsGrid'
import AccountsList from './AccountsList'
import AccountsListCepIntegration from './AccountsListCepIntegration'

type Props = {
  accounts: IntegrationAccount[] | CepIntegration[]
  isTableView: boolean
  isSimplifiedProjectIntegrationOn: boolean
  onUpdate: (integrationAccount: IntegrationAccount | CepIntegration) => void
  onDelete: (integrationAccount: IntegrationAccount | CepIntegration) => void
}

const AccountsView = ({
  accounts,
  isTableView,
  isSimplifiedProjectIntegrationOn,
  onUpdate,
  onDelete,
}: Props) => {
  if (isSimplifiedProjectIntegrationOn) {
    const Component = isTableView
      ? AccountsListCepIntegration
      : AccountGridCepIntegration
    return (
      <Component
        accounts={accounts as CepIntegration[]}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    )
  }

  const Component = isTableView ? AccountsList : AccountsGrid
  return (
    <Component
      accounts={accounts as IntegrationAccount[]}
      onUpdate={onUpdate}
      onDelete={onDelete}
    />
  )
}

export default AccountsView
